// First-party, cookie-free tracking. No third parties, admin pages excluded.
const API = process.env.REACT_APP_BACKEND_URL;

export function track(event, path, meta = {}) {
  try {
    if (navigator.webdriver) return;
    if (!path || path.startsWith("/admin")) return;
    let vid = localStorage.getItem("app_vid");
    if (!vid) {
      vid = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("app_vid", vid);
    }
    const body = { event, path, vid, width: window.innerWidth, meta };
    if (event === "pageview") body.referrer = document.referrer;
    fetch(`${API}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch { /* fire-and-forget */ }
}
